(function () {
  function fixDrawerScroll() {
    const el = document.querySelector('.drawer__content__scroll[data-scroll-lock-scrollable]');
    if (!el) return;

    // Remove scroll-lock inline overrides (these beat CSS)
    el.style.removeProperty('height');
    el.style.removeProperty('max-height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('overflow-y');
    el.style.removeProperty('-webkit-overflow-scrolling');

    // Now apply what we actually want
    el.style.height = 'auto';
    el.style.maxHeight = 'none';
    el.style.overflow = 'hidden';
  }

  // Run whenever scroll-lock activates (menu opens)
  const obs = new MutationObserver(() => {
    if (document.body.hasAttribute('data-scroll-lock-locked')) {
      setTimeout(fixDrawerScroll, 50);
    }
  });

  obs.observe(document.body, { attributes: true, attributeFilter: ['data-scroll-lock-locked'] });

  // Also run once on load just in case
  document.addEventListener('DOMContentLoaded', () => setTimeout(fixDrawerScroll, 200));
})();
document.addEventListener('DOMContentLoaded', () => {
  const unlock = () => {
    const el = document.querySelector('.drawer__content__scroll[data-scroll-lock-scrollable]');
    if (!el) return;

    // remove the inline scroll-lock styles that create the scrollbar
    el.style.removeProperty('height');
    el.style.removeProperty('max-height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('overflow-y');
    el.style.removeProperty('-webkit-overflow-scrolling');

    // ensure it doesn't become its own scroll container
    el.style.overflow = 'visible';
    el.style.maxHeight = 'none';
    el.style.height = 'auto';
  };

  // run on open + after animation
  document.addEventListener('click', (e) => {
    if (e.target.closest('.header__mobile__hamburger, [data-drawer-toggle], button[aria-controls="header-menu"]')) {
      setTimeout(unlock, 50);
      setTimeout(unlock, 300);
      setTimeout(unlock, 800);
    }
  });

  setTimeout(unlock, 800);
});
